import { getLabelKebabCase } from './metric-selector-modal-pipes-utils';
import * as i0 from "@angular/core";
/**
 * Create a unique string to identify the first element in a category's metric column.
 * This is used to scroll to the top of each category's metrics.
 *
 * Value:
 *   metricByCategoryListId: The string identifying which component extending MetricByCategoryListDirective includes
 *     the item to scroll to. This is necessary because more than one of those components can exist on the same page.
 *
 * Params:
 *   categoryLabel: The label of the category this is the broadest way metrics are grouped.
 *
 */
export class GetCategoryTopScrollIdPipe {
    transform(metricByCategoryListId, categoryLabel) {
        return getLabelKebabCase([categoryLabel, 'category-top', metricByCategoryListId]);
    }
}
GetCategoryTopScrollIdPipe.ɵfac = function GetCategoryTopScrollIdPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GetCategoryTopScrollIdPipe)(); };
GetCategoryTopScrollIdPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getCategoryTopScrollId", type: GetCategoryTopScrollIdPipe, pure: true, standalone: false });
